<template>
  <div class="lds-ring" v-if="isLoading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
  </div>
  <!-- <div v-if="isVisible" class="loader-overlay">
      <div class="loader"></div>
      <span class="text" v-html="text"></span>
  </div> -->
</template>

<script>

import { defineComponent, computed } from "vue";

export default defineComponent({
    name: "LoaderSpinnner",
    props: {
      isLoading: {
        type: Boolean,
        required: true,
      },
    },
    setup(props) {

    }
   
  });
  </script>

<style lang="scss" scoped>
  .lds-ring {
  display: inline-block;
  position: relative;
  width: 30px;
  height: 30px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 28px;
  height: 28px;
  margin: 4px;
  border: 4px solid #495057;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #495057 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
<!-- <template>
    <img src="../../assets/loading.gif" >
</template>

<script>
    export default {
        name: "loader-componente",

    }
</script>

<style lang="scss">
  

    
</style> -->